/// <amd-module name="Wit/WorkItems/Utilities/FieldUtilities" />
import { equals } from "VSS/Core/Util/String";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { FieldType } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { CoreFieldRefNames } from "Wit/Common/CoreFieldRefNames";
import { FieldValueMap, FieldValueType, IWorkItemTypeField } from "Wit/WorkItemTypes/Contracts";

export function areFieldValuesDifferent(typeField: IWorkItemTypeField, originalValue: FieldValueType, newValue: FieldValueType): boolean {
    if (isValueNullOrEmpty(newValue) && isValueNullOrEmpty(originalValue)) {
        return false;
    } else if (isValueNullOrEmpty(newValue) && !isValueNullOrEmpty(originalValue)) {
        return true;
    } else if (!isValueNullOrEmpty(newValue) && isValueNullOrEmpty(originalValue)) {
        return true;
    }

    if (equals(typeField.referenceName, CoreFieldRefNames.History, true)) {
        return true;
    }

    if (typeField.isIdentity) {
        const newIdentifier = (newValue as IdentityRef).descriptor || (newValue as IdentityRef).displayName;
        const originalIdentifier = (originalValue as IdentityRef).descriptor || (originalValue as IdentityRef).displayName;
        return !equals(newIdentifier, originalIdentifier, true);
    }

    switch (typeField.type) {
        case FieldType.DateTime:
            const newDate = newValue as Date;
            const originalDate = originalValue as Date;
            return newDate.getTime() !== originalDate.getTime();
        default:
            return newValue !== originalValue;
    }
}

function isValueNullOrUndefined(value: any): boolean {
    return value === null || value === undefined;
}

export function isValueNullOrEmpty(value: any): boolean {
    return isValueNullOrUndefined(value) || (typeof value === "string" && value === "");
}

export function isValueNullOrWhitespace(value: any): boolean {
    return isValueNullOrUndefined(value) || (typeof value === "string" && value.trim() === "");
}

/**
 * Transform the given field value map so that all keys are lowercase
 */
export function transformFieldReferenceNames(fields: FieldValueMap): FieldValueMap {
    const result: FieldValueMap = {};
    for (const fieldReferenceName of Object.keys(fields)) {
        result[fieldReferenceName.toLocaleLowerCase()] = fields[fieldReferenceName];
    }
    return result;
}
